// Favre — logo FH w nagłówku (2026-10-23): kafelek przechodzi biały ↔ czarny z efektem z filmu,
// gdy zmienia się kolor nagłówka (przezroczysty nad hero = biały tekst → biały kafelek; biały nagłówek → czarny).
// Stan czytamy z koloru tekstu linku logo (CSS hero ustawia --color-foreground 255,255,255 w stanie przezroczystym),
// więc logo zawsze zgadza się z resztą nagłówka (scroll, hover, otwarte menu, fokus).
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const init = () => {
    document.querySelectorAll('[data-favre-fh]').forEach((el) => {
      if (el.__fh) return;
      el.__fh = true;
      const zrodlo = el.closest('.header__heading-link') || el.parentElement;
      const naglowek = el.closest('.section-header') || document;
      const jasny = () => {
        const m = getComputedStyle(zrodlo).color.match(/\d+/g);
        if (!m) return false;
        return (Number(m[0]) + Number(m[1]) + Number(m[2])) / 3 > 160;
      };
      let stan = jasny();
      el.classList.toggle('is-weiss', stan);
      const sprawdz = () => {
        const teraz = jasny();
        if (teraz === stan) return;
        stan = teraz;
        el.classList.remove('anim-weiss', 'anim-schwarz', 'is-weiss');
        if (reduce.matches) { el.classList.toggle('is-weiss', stan); return; }
        void el.offsetWidth; // restart animacji
        el.classList.add(stan ? 'anim-weiss' : 'anim-schwarz');
      };
      let raf = 0;
      const planuj = () => {
        if (raf) return;
        raf = requestAnimationFrame(() => { raf = 0; sprawdz(); });
        // kolor nagłówka ma przejście 0,3 s — sprawdzamy jeszcze po nim
        setTimeout(sprawdz, 340);
      };
      addEventListener('scroll', planuj, { passive: true });
      ['mouseenter', 'mouseleave', 'focusin', 'focusout', 'toggle'].forEach((t) => naglowek.addEventListener(t, planuj, true));
      if (naglowek !== document) new MutationObserver(planuj).observe(naglowek, { attributes: true, attributeFilter: ['class'] });
      addEventListener('pageshow', planuj);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
